export default __webpack_public_path__ + "static/media/Empty.a1532b78.svg";